/* To-dos design tokens — directive §16. One source for the whole screen. */
export const T = {
  page: "#EDEAE3",
  card: "#FFFFFF",
  cardEdge: "#DAD5CA",
  groupHeader: "#FBFAF7",
  rule: "#EFECE4",
  ink: "#1A1A1A",
  ink2: "#59554D",
  muted: "#8A857C",
  faint: "#A8A399",
  overdue: "#D24317",
  dueToday: "#8A6D00",
  accent: "#FFD108",
  accentEdge: "#E0B800",
  accentInk: "#121212",
  menuHover: "#F5F2EA",
  inProgress: "#2A4C7A",
  done: "#1E6B3A",
  doneFill: "#2E8B52",
};

export const MANROPE = { fontFamily: "Manrope, sans-serif" };
export const FOCUS = "focus:outline-none focus:ring-[3px] focus:ring-[#FFD108]/45";
export const MENU_SHADOW = "0 10px 28px rgba(18,18,18,0.14)";

/* Types — directive §7. Follow-up is blue so it can't be read as an Action,
   Check-in is neutral so it can't be read as a Task. Health check is the fifth
   type the user added; pink keeps it clear of all four. */
export const TYPES = {
  action: { label: "Action", plural: "Actions", fill: "#FFF3CE", ink: "#6B5600", border: "#EADFBE" },
  task: { label: "Task", plural: "Tasks", fill: "#EAF6EE", ink: "#1E6B3A", border: "#BEDDC9" },
  follow_up: { label: "Follow-up", plural: "Follow-ups", fill: "#EEF3FA", ink: "#2A4C7A", border: "#C9D9EE" },
  check_in: { label: "Check-in", plural: "Check-ins", fill: "#F1EEE6", ink: "#59554D", border: "#DAD5CA" },
  health_check: { label: "Health check", plural: "Health checks", fill: "#FBE3EF", ink: "#B02A6B", border: "#F0C5DC" },
};
export const TYPE_ORDER = ["action", "task", "follow_up", "check_in", "health_check"];

export const STATUS = {
  open: { label: "Open", fill: "#FFFFFF", border: "#DAD5CA", ink: "#59554D", dot: null, ring: "#8A857C" },
  in_progress: { label: "In progress", fill: "#EEF3FA", border: "#C9D9EE", ink: "#2A4C7A", dot: "#2A6FD1" },
  done: { label: "Done", fill: "#E8F3EC", border: "#BEDDC9", ink: "#1E6B3A", dot: "#2E8B52" },
};

const MONTHS = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

export const ddMon = (iso, thisYear) => {
  if (!iso) return "No date";
  const d = new Date(`${String(iso).slice(0, 10)}T00:00:00`);
  if (Number.isNaN(d.getTime())) return String(iso).slice(0, 10);
  const base = `${String(d.getDate()).padStart(2, "0")} ${MONTHS[d.getMonth()]}`;
  return d.getFullYear() === thisYear ? base : `${base} ${d.getFullYear()}`;
};

export const dayDiff = (iso, today) =>
  Math.round((new Date(`${String(iso).slice(0, 10)}T00:00:00`) - new Date(`${today}T00:00:00`)) / 86400000);

/* The bucket is worked out from the due date every time, never stored, so a
   date change re-groups the row straight away (directive §8). */
export const dueBucket = (iso, today, weekEnd) => {
  if (!iso) return "no_date";
  const d = String(iso).slice(0, 10);
  if (d < today) return "overdue";
  if (d === today) return "due_today";
  return d <= weekEnd ? "this_week" : "later";
};

export const DUE_GROUPS = [
  { key: "overdue", label: "Overdue", tone: T.overdue },
  { key: "due_today", label: "Due today", tone: T.dueToday },
  { key: "this_week", label: "This week", tone: T.ink },
  { key: "later", label: "Later", tone: T.ink },
  { key: "no_date", label: "No date", tone: T.ink2 },
];

export const weekEndOf = (today) => {
  const d = new Date(`${today}T00:00:00`);
  d.setDate(d.getDate() + ((7 - (d.getDay() || 7)) % 7));
  return d.toISOString().slice(0, 10);
};

export const relativeLine = (iso, today, status) => {
  if (status === "done") return { text: "Done", color: T.muted, bold: false };
  if (!iso) return { text: "Set date", color: T.faint, bold: false };
  const n = dayDiff(iso, today);
  if (n < 0) return { text: `${-n} day${n === -1 ? "" : "s"} late`, color: T.overdue, bold: true };
  if (n === 0) return { text: "Today", color: T.dueToday, bold: true };
  return { text: `in ${n} day${n === 1 ? "" : "s"}`, color: T.muted, bold: false };
};
